import type { SVGProps } from 'react';
import type { SVGRType } from '../types';

const SvgAdd = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRType) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    viewBox='0 0 24 24'
    width='24'
    height='24'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M5 12C5 11.4898 5.42652 11.0633 5.93668 11.0633H11.0633V5.93668C11.0633 5.42652 11.4898 5 12 5C12.5102 5 12.9367 5.42652 12.9367 5.93668V11.0633H18.0633C18.5735 11.0633 19 11.4898 19 12C19 12.5185 18.5735 12.9367 18.0633 12.9367H12.9367V18.0633C12.9367 18.5735 12.5102 19 12 19C11.4898 19 11.0633 18.5735 11.0633 18.0633V12.9367H5.93668C5.42652 12.9367 5 12.5185 5 12Z' />
  </svg>
);

export default SvgAdd;
